import React, {useContext} from 'react';
import {Heading,} from './TripDatesModal.style';
import {IdemDateTimePicker} from "../../components/DateRangePickerWrapper/StyledDateTimePicker";
import {AuthContext} from "contexts/auth/auth.provider";
import moment from "moment-timezone";
import {CartContext} from "contexts/cart/cart.context";
import {useFormik} from "formik";
import * as Yup from "yup";


export default function TripDatesModal({onOk, ...props}) {

    const {deviceType} = useContext(AuthContext);
    const {
        cart: {products, orderEndTime, orderStartTime, region, fulfillmentCenter,},
        setOrderStartTime,
        setOrderEndTime,
        setRegion
    } = useContext(CartContext);


    const {getFieldProps, handleSubmit, errors, values, setFieldValue} = useFormik({
        enableReinitialize: true,
        initialValues: {
            region,
            orderStartTime,
            orderEndTime
        },
        onSubmit,
        validationSchema: Yup.object().shape({
            region: Yup.string().required('Please select your region').nullable(),
            orderStartTime: Yup.string().required('Please select your trip dates').nullable(),
            orderEndTime: Yup.string().required('Please select your trip dates').nullable(),
        })
    });


    function onSubmit({region, orderStartTime, orderEndTime}) {
        setRegion(region);
        setOrderStartTime(orderStartTime);
        setOrderEndTime(orderEndTime);
        onOk();
    }

    return (
        <div className="rounded-lg text-center">
            <div className="p-4 pt-6 sm:p-10 sm:pt-10 rounded-lg">
                <Heading className="text-scuttle-blue">
                    Welcome
                </Heading>


                <p className="mt-8 text-gray-500 font-normal my-4">Where will you receive the products? </p>

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <select id="location"
                                {...getFieldProps('region')}
                                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
                        <option value={null}>Please select your region</option>
                            <option value={"Eastern Cape"}>Eastern Cape</option>
                            <option value={"Free State"}>Free State</option>
                            <option value={"Gauteng North"}>Gauteng North</option>
                            <option value={"Gauteng South"}>Gauteng South</option>
                            <option value={"KwaZulu-Natal"}>KwaZulu-Natal</option>
                            <option value={"Limpopo"}>Limpopo</option>
                            <option value={"Mpumalanga"}>Mpumalanga</option>
                            <option value={"Northern Cape"}>Northern Cape</option>
                            <option value={"North West"}>North West</option>
                            <option value={"Western Cape"}>Western Cape</option>
                        </select>
                        {
                            errors.region && <p className="my-1 text-sm text-red-700">
                                {errors.region}
                            </p>
                        }
                    </div>


                    {region && products.length > 0 &&
                    <div className="mb-2 bg-yellow-50 border-l-4 border-yellow-400 p-4">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                {/* Heroicon name: solid/exclamation */}
                                <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fillRule="evenodd"
                                          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"/>
                                </svg>
                            </div>
                            <div className="ml-3">
                                <p className="text-sm text-yellow-700">
                                    Updating your Location again will remove the items in your cart.
                                </p>
                            </div>
                        </div>
                    </div>}


                    <p className="mt-8 mb-4 text-gray-500 font-normal">Please select your rental{" "}<span
                        className="text-gray-800 font-bold">Start Date</span>
                        &nbsp;and <span className="text-gray-800 font-bold">End Date</span></p>

                    <IdemDateTimePicker
                        heading={false}
                        numberOfMonths={deviceType?.mobile ? 1 : 2}
                        placement={deviceType?.mobile ? "top" : "bottom"}
                        showResetDates={false}
                        startDate={values.orderStartTime ? moment.tz(values.orderStartTime, 'Africa/Johannesburg').toDate() : null}
                        endDate={values.orderEndTime ? moment.tz(values.orderEndTime, 'Africa/Johannesburg').toDate() : null}
                        onTripDatesChange={(data) => {
                            console.log('hoof', data);
                            setFieldValue('orderStartTime', moment.tz(data.startDate, 'Africa/Johannesburg').toISOString());
                            setFieldValue('orderEndTime', data.endDate ? moment.tz(data.endDate, 'Africa/Johannesburg').toISOString() : null);
                        }}
                        {...props}
                    />
                    {
                        (errors.orderStartTime || errors.orderEndTime) && <p className="mb-2 text-sm text-red-700">
                            {errors.orderStartTime || errors.orderEndTime}
                        </p>
                    }

                    <p className="text-md leading-6 font-semibold text-scuttle-orange">
                        Receive Products
                        - {values.orderStartTime ? moment.tz(values.orderStartTime, 'Africa/Johannesburg').subtract(1, 'day').format('ddd DD MMM') : 'Day before Start Date'}
                    </p>
                    <p className="text-md leading-6  font-semibold text-scuttle-orange">
                        Return Products
                        - {values.orderEndTime ? moment.tz(values.orderEndTime, 'Africa/Johannesburg').add(1, 'day').format('ddd DD MMM') : 'Day after End Date'}
                    </p>

                    {fulfillmentCenter && <p className="text-sm leading-6  font-semibold text-scuttle-orange">
                        Fulfilled from
                        - {fulfillmentCenter}
                    </p>}


                    <div className="mt-5 sm:mt-6 ">
                     <span className="flex w-full rounded-md shadow-sm">
                          <button type="submit"
                                  className="inline-flex justify-center w-full items-center px-4 py-2.5 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-scuttle-orange focus:outline-none transition ease-in-out duration-150">
                         Continue
                          </button>
                        </span>
                    </div>

                    <div className="mt-5 sm:mt-6 ">
                     <span className="flex w-full rounded-md shadow-sm">
                          <button type="button"
                                  onClick={onOk}
                                  className="inline-flex justify-center w-full items-center px-4 py-2 border border-scuttle-orange text-base leading-6 font-medium rounded-md text-scuttle-orange focus:outline-none transition ease-in-out duration-150">
                           I'll do this later
                          </button>
                        </span>
                    </div>
                </form>
            </div>
        </div>
    );
}
